
import styled from 'styled-components';


/*

Props:

• defaultStyles
• width


*/

export const ShowWidth = styled.div`


    @media (min-width: ${props => (props.width) ? props.width : '0'}px){
        display: none;
        }

    ${props => (props.defaultStyles) ? props.defaultStyles : ''}

`;



// WEBPACK FOOTER //
// ./src/js/components/ShowWidth.jsx